import { ListItemText } from "@mui/material"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

export interface LocationOption {
  label: React.ReactNode
  locationId: string
  companyId?: string
}

export const mapLocationOptions = (locations: Location[]): LocationOption[] =>
  locations.map((location) => ({
    label: (
      <ListItemText
        primary={location.address1 || "-"}
        secondary={formatLocationAddress(location, AddressFormat.Long)}
      />
    ),
    locationId: location.locationId,
    companyId: location.companyId,
  }))
